// Little Oak — Golden Hour shared components. Presentation only: data comes in through props.
import { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";

export const inr = (n) => "₹" + new Intl.NumberFormat("en-IN").format(Math.round(n || 0));

const P = {
  menu: "M4 7h16M4 12h16M4 17h10", close: "M6 6l12 12M18 6L6 18",
  bag: "M6 8h12l-1 12H7L6 8zM9 8V6.5a3 3 0 016 0V8", search: "M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4",
  arrow: "M5 12h13M13 6l6 6-6 6", down: "M6 9l6 6 6-6", plus: "M12 5v14M5 12h14", minus: "M5 12h14", check: "M5 12.5l4.2 4.2L19 7",
  truck: "M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19a1.6 1.6 0 100-3.2A1.6 1.6 0 007 19zM17.5 19a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z",
  gift: "M4 10h16v10H4zM3 7h18v3H3zM12 7v13M12 7c-1.8-3.4-5.6-3.2-5.6-1 0 1.4 2 1 5.6 1zm0 0c1.8-3.4 5.6-3.2 5.6-1 0 1.4-2 1-5.6 1z",
  pen: "M15.5 4.5l4 4L8 20H4v-4L15.5 4.5zM13.5 6.5l4 4",
  leaf: "M12 3c4.6 3.2 6.5 7.2 5.8 11.1-.7 3.5-3.4 5.8-5.8 7.4-2.4-1.6-5.1-3.9-5.8-7.4C5.5 10.2 7.4 6.2 12 3zM12 7v14",
  sparkle: "M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18",
  seal: "M12 3l2.2 1.6 2.7-.2.8 2.6 2.2 1.6-.9 2.5.9 2.5-2.2 1.6-.8 2.6-2.7-.2L12 21l-2.2-1.6-2.7.2-.8-2.6-2.2-1.6.9-2.5-.9-2.5 2.2-1.6.8-2.6 2.7.2L12 3zM9 12l2 2 4-4",
  heart: "M12 20s-7-4.4-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.6-7 10-7 10z", home: "M4 11l8-7 8 7v9H4zM10 20v-5h4v5",
  play: "M8 5.5v13l11-6.5z",
  whatsapp: "M4 20l1.3-4A8 8 0 1112 20a8 8 0 01-4-1.1L4 20zM9 8.5c0 3.6 2.9 6.5 6.5 6.5l1-1.6-2-1-1 .9c-1.2-.5-2.3-1.6-2.8-2.8l.9-1-1-2L9 8.5z",
  box: "M3 8l9-4 9 4-9 4-9-4zM3 8v8l9 4 9-4V8M12 12v8",
  flame: "M12 3c2 3 5 5 5 9a5 5 0 01-10 0c0-2 1-3.5 2-4.5.3 1.7 1 2.5 2 3-.5-2.5.2-5 1-7.5z",
  cash: "M3 7h18v10H3zM12 15a3 3 0 100-6 3 3 0 000 6zM6 10v4M18 10v4",
  baby: "M12 4a3 3 0 100 6 3 3 0 000-6zM7 21v-4a5 5 0 0110 0v4M9 14l3 2 3-2",
  star: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z",
  users: "M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20a6.5 6.5 0 0113 0M16 4.5a3.5 3.5 0 010 6.8M21.5 20a6.5 6.5 0 00-4.5-6.2",
  brush: "M14 4l6 6-8 8a3 3 0 01-4 0l-2-2a3 3 0 010-4l8-8zM5 19c-1 0-2 1-2 2",
  tag: "M3 12V4h8l10 10-8 8L3 12zM7.5 8.5h.01", invoice: "M6 3h12v18l-3-2-3 2-3-2-3 2V3zM9 8h6M9 12h6M9 16h3",
  clock: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2",
};
export function Icon({ name, size, className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={P[name]} fill={name === "play" ? "currentColor" : "none"} />
    </svg>
  );
}
export const Arrow = () => <Icon name="arrow" className="lo-i-arrow" />;

export function Leaf({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path className="leaf-fill" d="M12 1.8c4.9 3.4 7 7.7 6.2 11.9-.8 3.8-3.7 6.3-6.2 8-2.5-1.7-5.4-4.2-6.2-8C5 9.5 7.1 5.2 12 1.8z" />
      <path className="leaf-vein" d="M12 6v15M12 10.6l-2.7-2.1M12 14.2l3.1-2.5M12 17.8l-2.5-2" fill="none" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
}
export function Logo() {
  return <Link to="/" className="lo-logo" aria-label="Little Oak home"><Leaf /><span>Little Oak</span></Link>;
}
export function Diya() {
  return (
    <svg className="lo-diya" viewBox="0 0 28 20" aria-hidden="true">
      <path d="M2 11.5c2.5 5 7 7 12 7s9.5-2 12-7H2z" fill="#C98A4B" />
      <path d="M2 11.5h24" stroke="#E1A22A" strokeWidth="1.2" />
      <path className="flame" d="M14 1.2c1.6 2.4 3 3.8 3 6a3 3 0 01-6 0c0-1.3.6-2.2 1.2-2.9.2 1 .6 1.5 1.2 1.8-.3-1.6.1-3.2.6-4.9z" fill="#F2B562" />
    </svg>
  );
}

let sealN = 0;
export function Seal({ text = "Re-pour Promise · broken? poured again free · ", className = "", style }) {
  const id = useMemo(() => `s${++sealN}`, []);
  return (
    <div className={`lo-seal ${className}`} style={style} role="img" aria-label="Re-pour Promise: arrives broken, we pour it again free">
      <svg viewBox="0 0 120 120" width="100%" height="100%" style={{ position: "absolute", inset: 0 }} aria-hidden="true">
        <defs>
          <radialGradient id={`${id}w`} cx="38%" cy="32%" r="75%"><stop offset="0" stopColor="#B84A33" /><stop offset=".55" stopColor="#8E2C1C" /><stop offset="1" stopColor="#5E180F" /></radialGradient>
          <filter id={`${id}f`} x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency=".05" numOctaves="2" seed="7" /><feDisplacementMap in="SourceGraphic" scale="6" /></filter>
        </defs>
        <circle cx="60" cy="60" r="56" fill={`url(#${id}w)`} filter={`url(#${id}f)`} />
        <circle cx="60" cy="60" r="49" fill="none" stroke="rgba(255,220,190,.22)" strokeWidth="1" />
        <circle cx="60" cy="60" r="27" fill="none" stroke="rgba(0,0,0,.25)" strokeWidth="1.5" />
      </svg>
      <svg className="lo-seal__ring" viewBox="0 0 120 120" width="100%" height="100%" aria-hidden="true">
        <defs><path id={`${id}p`} d="M60,60 m-39,0 a39,39 0 1,1 78,0 a39,39 0 1,1 -78,0" /></defs>
        <text><textPath href={`#${id}p`} textLength="242" lengthAdjust="spacing">{text.toUpperCase()}</textPath></text>
      </svg>
      <span className="lo-seal__core"><Leaf /></span>
    </div>
  );
}

// Film: plays a muted looping video only while on screen; otherwise (no URL, reduced motion,
// Save-Data, off screen) it shows the poster with slow drift and breathing window light.
export function Film({ poster, video, focal, alt = "", eager = false }) {
  const ref = useRef(null);
  const [play, setPlay] = useState(false);
  useEffect(() => {
    if (!video || !ref.current) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    const el = ref.current;
    const io = new IntersectionObserver(([e]) => {
      const v = el.querySelector("video");
      if (e.isIntersecting) { setPlay(true); v && v.play && v.play().catch(() => {}); }
      else if (v) v.pause();
    }, { rootMargin: "200px" });
    io.observe(el);
    return () => io.disconnect();
  }, [video]);
  return (
    <div ref={ref} className="lo-media" style={{ "--focal": focal }}>
      {video && play ? (
        <video src={video} poster={poster} muted loop playsInline autoPlay preload="none" aria-label={alt} />
      ) : (
        <img src={poster} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" />
      )}
    </div>
  );
}
export function Arch({ poster, video, focal, alt, film = true, frame = true, className = "", eager, style, children }) {
  return (
    <div className={`lo-arch ${frame ? "lo-arch--frame" : ""} ${film && !video ? "lo-film" : ""} ${className}`} style={style}>
      {poster ? <Film poster={poster} video={film ? video : null} focal={focal} alt={alt} eager={eager} /> : null}
      {children}
    </div>
  );
}
export function Porthole({ poster, video, focal, alt, className = "" }) {
  return <div className={`lo-porthole ${video ? "" : "lo-film"} ${className}`}><Film poster={poster} video={video} focal={focal} alt={alt} /></div>;
}
export function Swash({ children }) {
  return (
    <span className="lo-swash">{children}
      <svg viewBox="0 0 200 20" preserveAspectRatio="none" aria-hidden="true"><path d="M3 13 C 40 6, 90 4, 197 9 M 30 16 C 80 12, 130 12, 170 14" /></svg>
    </span>
  );
}

export function Dots({ colours, max = 4 }) {
  if (!colours || !colours.length) return null;
  const extra = colours.length - max;
  return (
    <span className="lo-dots" aria-label={`${colours.length} colours`}>
      {colours.slice(0, max).map((c) => <i key={c.name} className="lo-dot" style={{ background: c.hex }} title={c.name} />)}
      {extra > 0 ? <small>+{extra}</small> : null}
    </span>
  );
}
// item = { to, name, card_line, price, image, imageLarge, focal, badge, colours:[{name,hex}], isBox, worth, pieces, hasFilm, alt }
export function ProductCard({ item, feature = false, style }) {
  return (
    <Link to={item.to} className={`lo-card ${feature ? "lo-card--feature" : ""}`} style={style} data-reveal>
      <div className="lo-card__media" style={{ "--focal": item.focal || "50% 50%" }}>
        {item.image ? <img src={feature ? item.imageLarge || item.image : item.image} alt={item.alt || item.name} loading="lazy" decoding="async" /> : null}
        {item.badge ? <span className="lo-badge lo-badge--dot">{item.badge}</span> : null}
        {item.hasFilm ? <span className="lo-card__film" title="Has a film"><Icon name="play" /></span> : null}
      </div>
      <div className="lo-card__body">
        <h3 className="lo-card__name">{item.name}</h3>
        {item.card_line ? <p className="lo-card__line">{item.card_line}</p> : null}
        <div className="lo-card__foot">
          <span className="lo-price">{inr(item.price)}{item.perPiece ? <small className="lo-tiny" style={{ marginLeft: 6, fontWeight: 500 }}>{item.perPiece}</small> : null}</span>
          {item.isBox ? (item.worth > item.price ? <span className="lo-card__worth">Worth {inr(item.worth)}</span> : item.pieces ? <span className="lo-card__worth">{item.pieces} pieces</span> : null) : <Dots colours={item.colours} />}
        </div>
      </div>
    </Link>
  );
}

export function SectionHead({ eyebrow, title, lede, action, center, split, as = "h2" }) {
  const H = as;
  return (
    <div className={`lo-head ${center ? "lo-head--center" : ""} ${split ? "lo-head--split" : ""}`}>
      <div className="lo-stack" style={{ gap: 18 }}>
        {eyebrow ? <span className="lo-eyebrow">{eyebrow}</span> : null}
        <H className="lo-display lo-h2" data-reveal>{title}</H>
      </div>
      {lede || action ? (
        <div className="lo-stack" style={{ gap: 18, justifyItems: center ? "center" : "start" }}>
          {lede ? <p className="lo-lede" data-reveal>{lede}</p> : null}
          {action}
        </div>
      ) : null}
    </div>
  );
}
export function Marquee({ items }) {
  const row = items.map((t, i) => <span className="lo-marquee__item" key={i}>{t}<Icon name="leaf" /></span>);
  return <div className="lo-marquee" aria-label={items.join(". ")}><div className="lo-marquee__track" aria-hidden="true">{row}{row}</div></div>;
}
export function Offers({ offers }) {
  return <ul className="lo-offers">{offers.map((o) => <li key={o}><Icon name="sparkle" />{o}</li>)}</ul>;
}
export function NoteCard({ id = "note", value, onChange, initial = "Happy Diwali, Maa.\nThe diyas are on me this year.\n— Riya" }) {
  const [own, setOwn] = useState(initial);
  const text = value !== undefined ? value : own;
  const set = onChange || setOwn;
  return (
    <div className="lo-notecard-ui">
      <div className="lo-field">
        <label htmlFor={id}>Your note</label>
        <textarea id={id} className="lo-textarea" maxLength={150} value={text} onChange={(e) => set(e.target.value)} rows={5} />
        <span className="lo-hint">{150 - text.length} characters left · we write it out by hand</span>
      </div>
      <div style={{ paddingTop: 26 }}>
        <div className="lo-notecard" aria-live="polite">
          <svg className="lo-notecard__twine" viewBox="0 0 80 66" aria-hidden="true"><path d="M40 60 C 30 40, 10 30, 4 2 M40 60 C 50 40, 70 30, 76 2" fill="none" stroke="#B08A5A" strokeWidth="2" strokeLinecap="round" /></svg>
          <div className="lo-notecard__text">{text || "Write something they'll keep."}</div>
          <div className="lo-notecard__sign"><span>Little Oak · Pune</span><Leaf /></div>
        </div>
      </div>
    </div>
  );
}

// Reveal-on-scroll that never strands content: nothing hides until the visitor scrolls.
export function useReveal(routeKey) {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const root = document.documentElement;
    let pending = []; let raf = 0;
    const collect = () => { pending = [...document.querySelectorAll("[data-reveal]:not(.is-in)")]; };
    const check = () => { raf = 0; const lim = window.innerHeight * 0.92; pending = pending.filter((el) => { if (el.getBoundingClientRect().top < lim) { el.classList.add("is-in"); return false; } return true; }); };
    const scan = () => { collect(); check(); };
    const onScroll = () => { if (!root.classList.contains("reveal-armed")) { scan(); root.classList.add("reveal-armed"); return; } if (!raf) raf = requestAnimationFrame(check); };
    let t; if (root.classList.contains("reveal-armed")) t = setTimeout(scan, 30);
    // Content can mount after this effect runs (async product/catalogue fetches). Once the page is
    // "armed", such elements start hidden via CSS; re-scan on DOM changes so they are never stranded invisible.
    let moRaf = 0;
    const mo = new MutationObserver(() => { if (!root.classList.contains("reveal-armed") || moRaf) return; moRaf = requestAnimationFrame(() => { moRaf = 0; scan(); }); });
    mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener("scroll", onScroll, { passive: true }); window.addEventListener("resize", onScroll);
    return () => { clearTimeout(t); cancelAnimationFrame(raf); cancelAnimationFrame(moRaf); mo.disconnect(); window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); };
  }, [routeKey]);
}
// Call once per route change: replays the page-load animations (.lo-in, .lo-arch-in, .lo-pop, swash).
export function usePageLoad(routeKey) {
  useEffect(() => { const r = document.documentElement; r.classList.remove("lo-load"); void r.offsetWidth; r.classList.add("lo-load"); }, [routeKey]);
}

export function Announcement({ children }) {
  return <div className="lo-announce"><div className="lo-wrap lo-announce__in"><Diya /><span>{children}</span></div></div>;
}

export const NAV = [
  { to: "/shop", label: "Shop" },
  { to: "/gift-boxes", label: "Gift boxes" },
  { to: "/festivals", label: "Diwali", hot: true },
  { to: "/gift-finder", label: "Gift Finder" },
  { to: "/bulk", label: "Bulk orders" },
];
export function Header({ pathname, cartCount, onCartOpen, hotNote = "Order by 1 Nov", minimal = false, whatsappHref = null, festive = true }) {
  const nav = festive ? NAV : NAV.filter((n) => !n.hot);
  const [stuck, setStuck] = useState(false);
  const [night, setNight] = useState(false);
  const [menu, setMenu] = useState(false);
  useEffect(() => {
    let raf = 0;
    const tick = () => {
      raf = 0; setStuck(window.scrollY > 8);
      let n = false;
      document.querySelectorAll("[data-night]").forEach((el) => { const r = el.getBoundingClientRect(); const pad = parseFloat(el.dataset.night || "0"); if (r.top + pad <= 70 && r.bottom - pad >= 70) n = true; });
      setNight(n);
    };
    const on = () => { if (!raf) raf = requestAnimationFrame(tick); };
    tick(); window.addEventListener("scroll", on, { passive: true }); window.addEventListener("resize", on);
    return () => { window.removeEventListener("scroll", on); window.removeEventListener("resize", on); cancelAnimationFrame(raf); };
  }, [pathname]);
  useEffect(() => { setMenu(false); }, [pathname]);
  useEffect(() => { document.body.style.overflow = menu ? "hidden" : ""; }, [menu]);
  if (minimal) {
    return (
      <header className="lo-header is-stuck">
        <div className="lo-wrap lo-header__in lo-header__in--min" style={{ gridTemplateColumns: "1fr auto 1fr" }}>
          <Link to="/shop" className="lo-link" style={{ fontSize: 13.5, justifySelf: "start" }}>← <span className="lo-hide-sm">Keep shopping</span><span className="lo-show-sm">Shop</span></Link>
          <Logo />
          <span className="lo-secure" style={{ justifySelf: "end" }}><Icon name="seal" />Secure<span className="lo-hide-sm">&nbsp;checkout</span></span>
        </div>
      </header>
    );
  }
  return (
    <>
      <header className={`lo-header ${stuck ? "is-stuck" : ""} ${night ? "is-night" : ""}`}>
        <div className="lo-wrap lo-header__in">
          <div className="lo-header__left">
            <button className="lo-iconbtn lo-burger" onClick={() => setMenu(true)} aria-label="Open menu"><Icon name="menu" /></button>
            <nav className="lo-nav" aria-label="Main">
              {nav.map((n) => <Link key={n.to} to={n.to} className={n.hot ? "lo-nav__diwali" : ""} aria-current={pathname.startsWith(n.to) ? "page" : undefined}>{n.label}</Link>)}
            </nav>
          </div>
          <Logo />
          <div className="lo-header__right">
            <Link to="/gift-finder" className="lo-iconbtn" aria-label="Find a gift"><Icon name="gift" /></Link>
            <button className="lo-iconbtn" onClick={onCartOpen} aria-label={`Basket, ${cartCount} items`}><Icon name="bag" />{cartCount ? <span className="lo-count">{cartCount}</span> : null}</button>
          </div>
        </div>
      </header>
      {menu ? (
        <div className="lo-menu" role="dialog" aria-modal="true" aria-label="Menu">
          <div className="lo-menu__top"><Logo /><button className="lo-iconbtn" onClick={() => setMenu(false)} aria-label="Close menu"><Icon name="close" /></button></div>
          <nav className="lo-menu__links" aria-label="Menu">
            {nav.map((n) => <Link key={n.to} to={n.to}>{n.label}{n.hot && hotNote ? <small>{hotNote}</small> : null}</Link>)}
            <Link to="/kits">Kits <small style={{ color: "var(--sage-ink)" }}>Coming soon</small></Link>
            <Link to="/our-studio">Our studio</Link>
          </nav>
          <div className="lo-menu__foot">
            <nav aria-label="Help"><Link to="/re-pour-promise">Re-pour Promise</Link><Link to="/track">Track order</Link><Link to="/shipping">Shipping</Link><Link to="/refund-policy">Refunds</Link></nav>
            {whatsappHref ? <a className="lo-btn lo-btn--ghost" href={whatsappHref} target="_blank" rel="noreferrer"><Icon name="whatsapp" />Chat with us on WhatsApp</a> : null}
          </div>
        </div>
      ) : null}
    </>
  );
}

export function Footer({ onSubscribe, whatsappHref = null, settings = {}, onlineOn = true }) {
  const phone = settings.consumer_phone || settings.consumer_care_phone || "";
  const email = settings.consumer_email || settings.consumer_care_email || "";
  const hours = settings.consumer_hours || settings.consumer_care_hours || "";
  const legal = settings.legal_name || settings.legal_business_name || "";
  const addr = settings.address || settings.business_address || "";
  const gname = settings.grievance_name || settings.grievance_officer_name || "";
  const gemail = settings.grievance_email || settings.consumer_email || settings.consumer_care_email || "";
  const copyParts = [`© 2026 ${legal || "Little Oak"}`];
  if (legal) copyParts.push("Little Oak");
  if (addr) copyParts.push(addr);
  if (gname) copyParts.push(`Grievance Officer: ${gname}${gemail ? ", " + gemail : ""}`);
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    const phone = new FormData(e.currentTarget).get("wa");
    setBusy(true); setErr("");
    try { const r = await onSubscribe?.(String(phone)); setCode((r && r.data && r.data.code) || ""); setSent(true); }
    catch (ex) { setErr(ex?.response?.data?.detail || "That didn't go through. Check the number and try again."); }
    finally { setBusy(false); }
  };
  return (
    <footer className="lo-footer">
      <div className="lo-wrap">
        <div className="lo-footer__top">
          <div className="lo-stack" style={{ gap: 20, alignContent: "start" }}>
            <span className="lo-eyebrow">₹100 off your first order</span>
            <h2 className="lo-display lo-h3" style={{ color: "var(--night-ink)", maxWidth: "16ch" }}>Festival reminders and new pours, <em>on WhatsApp.</em></h2>
            <p className="lo-small" style={{ color: "var(--night-muted)", maxWidth: "44ch" }}>One message before each festival cut-off, and when a new batch is poured. Nothing else.</p>
            {sent ? (code ? (
              <div className="lo-stack" style={{ gap: 12 }} aria-live="polite">
                <p className="lo-hand" style={{ color: "var(--candle)", fontSize: 24 }}>Thank you. Here's your code:</p>
                <code className="lo-code-chip" style={{ justifySelf: "start", color: "var(--ink)" }} data-testid="footer-code">{code}</code>
                <p className="lo-small" style={{ color: "var(--night-muted)" }}>₹100 off your first order of ₹699 or more. Add it in your basket.</p>
              </div>
            ) : <p className="lo-hand" style={{ color: "var(--candle)", fontSize: 24 }} aria-live="polite">Thank you. You're on the list.</p>) : (
              <>
                <form className="lo-inline-form" onSubmit={submit}>
                  <label className="lo-sr" htmlFor="ft-wa">WhatsApp number</label>
                  <input id="ft-wa" name="wa" className="lo-input" type="tel" inputMode="numeric" autoComplete="tel" placeholder="WhatsApp number" required pattern="[0-9 +]{10,14}" />
                  <button className="lo-btn lo-btn--light" type="submit" disabled={busy}>Get ₹100 off</button>
                </form>
                {err ? <span className="lo-small" style={{ color: "var(--candle)" }} role="alert">{err}</span> : null}
              </>
            )}
          </div>
          <div className="lo-footer__cols">
            <div><h4>Shop</h4><Link to="/shop">All pieces</Link><Link to="/gift-boxes">Gift boxes</Link><Link to="/festivals">Diwali</Link><Link to="/gift-finder">Gift Finder</Link><Link to="/kits">Kits</Link></div>
            <div><h4>Policies</h4><Link to="/our-studio">About us</Link><Link to="/contact">Contact us</Link><Link to="/shipping">Shipping &amp; Delivery</Link><Link to="/refund-policy">Cancellation &amp; Refunds</Link><Link to="/re-pour-promise">Re-pour Promise</Link><Link to="/terms">Terms &amp; Conditions</Link><Link to="/privacy">Privacy Policy</Link></div>
            <div data-testid="footer-contact"><h4>Contact</h4>
              {phone ? <a href={`tel:${phone}`}>{phone}</a> : null}
              {email ? <a href={`mailto:${email}`}>{email}</a> : null}
              {hours ? <span style={{ display: "block", padding: "5px 0", fontSize: 15, opacity: 0.86 }}>{hours}</span> : null}
              <Link to="/track">Track your order</Link>
              <Link to="/bulk">Bulk &amp; custom</Link>
              {whatsappHref ? <a href={whatsappHref} target="_blank" rel="noreferrer">WhatsApp us</a> : null}
            </div>
          </div>
        </div>
        <div className="lo-footer__legal">
          <span>{copyParts.join(" · ")}</span>
          <span className="lo-stack" style={{ gap: 4, alignItems: "flex-end" }}>
            <span className="lo-payicons" data-testid="footer-payicons">{onlineOn ? <><span>UPI</span><span>VISA</span><span>MASTERCARD</span><span>RUPAY</span><span>COD</span></> : <span>COD</span>}</span>
            <span className="lo-tiny" style={{ opacity: 0.8 }} data-testid="footer-razorpay">Secure payments by Razorpay · UPI · Cards · Net-banking</span>
          </span>
        </div>
      </div>
      <span className="lo-wordmark" aria-hidden="true">Little Oak</span>
    </footer>
  );
}

// Basket drawer: structure + classes for the EXISTING cart logic (keep its data and server-computed nudges).
// lines = [{ key, name, image, focal, meta, qty, lineTotal, onInc, onDec }]
// code = { value, onChange, note, ok } (discount code field + status line); addons = [{ key, label, price, checked, onChange }] (never pre-ticked)
export function BasketDrawer({ open, onClose, lines, subtotalText, toFreeShipping, freeShipPct, nudges = [], discountLine, discountLines, code, addons = [], checkoutTo = "/checkout", onlineOn = true }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey); ref.current && ref.current.focus();
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const paid = lines.filter((l) => !l.gift);
  const discounts = discountLines || (discountLine ? [discountLine] : []);
  return (
    <>
      <div className="lo-drawer-bg" onClick={onClose} />
      <aside className="lo-drawer" role="dialog" aria-modal="true" aria-label="Your basket" tabIndex={-1} ref={ref}>
        <div className="lo-drawer__head"><h2>Your basket</h2><button className="lo-iconbtn" onClick={onClose} aria-label="Close basket"><Icon name="close" /></button></div>
        {paid.length ? (
          <div className="lo-drawer__nudges">
            <div className="lo-progress">
              <span>{toFreeShipping > 0 ? <>Add <b>{inr(toFreeShipping)}</b> more for free shipping</> : <><b>Free shipping</b> unlocked</>}</span>
              <div className="lo-progress__bar"><span style={{ width: `${freeShipPct}%` }} /></div>
            </div>
            {nudges.map((n) => <div className="lo-nudge" key={n}><Icon name="sparkle" />{n}</div>)}
          </div>
        ) : <div />}
        <div className="lo-drawer__items">
          {paid.length === 0 ? (
            <div className="lo-empty">
              <span className="lo-hand">Nothing here yet.</span>
              <p className="lo-small">Every piece arrives wrapped, with your note written by hand.</p>
              <Link to="/shop" className="lo-btn lo-btn--ghost" onClick={onClose}>Browse the pieces <Arrow /></Link>
            </div>
          ) : lines.map((l) => (
            <div className={`lo-line ${l.gift ? "lo-line--gift" : ""}`} key={l.key}>
              {l.image ? <img src={l.image} alt="" style={{ objectPosition: l.focal || "50% 50%" }} /> : <span className="lo-line__ph" aria-hidden="true"><Icon name={l.icon || "gift"} /></span>}
              <div>
                <h3>{l.name}</h3>
                {l.meta ? <p className="lo-tiny">{l.meta}</p> : null}
                {l.gift ? <span className="lo-badge lo-badge--gift">Free gift</span> : (
                  <div className="lo-line__ctl">
                    <div className="lo-qty">
                      <button onClick={l.onDec} aria-label={l.qty > 1 ? `One less ${l.name}` : `Remove ${l.name}`}><Icon name="minus" /></button>
                      <span>{l.qty}</span>
                      <button onClick={l.onInc} aria-label={`One more ${l.name}`}><Icon name="plus" /></button>
                    </div>
                    {l.onRemove ? <button className="lo-line__rm" onClick={l.onRemove}>Remove</button> : null}
                  </div>
                )}
              </div>
              <span className="lo-price">{l.gift ? "Free" : inr(l.lineTotal)}</span>
            </div>
          ))}
          {paid.length && addons.length ? (
            <div className="lo-addons">
              {addons.map((a) => (
                <label key={a.key} className="lo-check" htmlFor={`addon-${a.key}`}>
                  <input id={`addon-${a.key}`} type="checkbox" checked={!!a.checked} onChange={(e) => a.onChange(e.target.checked)} data-testid={`addon-${a.key}`} />
                  <span>{a.label} <span className="lo-tiny">+{inr(a.price)}</span></span>
                </label>
              ))}
            </div>
          ) : null}
        </div>
        {paid.length ? (
          <div className="lo-drawer__foot">
            {code ? (
              <div className="lo-code">
                <label className="lo-sr" htmlFor="cart-code">Discount code</label>
                <input id="cart-code" className="lo-input" placeholder="Discount code" value={code.value || ""} onChange={(e) => code.onChange(e.target.value.toUpperCase())} autoCapitalize="characters" spellCheck="false" data-testid="cart-code-input" />
                {code.value && code.note ? <span className={code.ok ? "lo-free" : "lo-tiny"} style={{ fontSize: 13 }} aria-live="polite">{code.note}</span> : null}
              </div>
            ) : null}
            {discounts.map((d) => <div key={d.label} className="lo-sum" style={{ fontWeight: 600, fontSize: 14 }}><span className="lo-free">{d.label}</span><span className="lo-free" style={{ fontFamily: "var(--f-body)", fontSize: 14 }}>−{inr(d.amount)}</span></div>)}
            <div className="lo-sum"><span>Subtotal</span><span>{subtotalText}</span></div>
            <Link to={checkoutTo} className="lo-btn lo-btn--primary lo-btn--block" onClick={onClose}>Checkout <Arrow /></Link>
            <p className="lo-tiny" style={{ textAlign: "center" }}>{onlineOn ? "UPI, cards or cash on delivery" : "Cash on delivery"} · gift-wrapped free</p>
          </div>
        ) : null}
      </aside>
    </>
  );
}
